import { render, staticRenderFns } from "./AdminOspitiView.vue?vue&type=template&id=698d86be&"
import script from "./AdminOspitiView.vue?vue&type=script&lang=ts&"
export * from "./AdminOspitiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports